
<div class="row" *ngIf="nextStep">
  <div class="col">
    <div class="alert alert-warning"><span><span>This step may be blocked pending completion of a previous step: </span><a [href]="nextStep?.url">{{ nextStep?.readableStepName }}</a></span></div>
  </div>
</div>
<div class="row" *ngIf="thisStepIsBlocked">
  <div class="col">
    <div class="alert alert-dark"><span><span>This step is marked as blocked.</span></span></div>
  </div>
</div>